export default [
  {
    id: '@customizeCodeRule',
    path: '/customize-code-rule',
    ref: '/',
    onload: () => import('./customize-code-rule'),
    store: () => import('./customize-code-store')
  }
]
